import { UserDTO } from './UserDTO'

export class UserCollectionDTO {
  constructor(readonly users: UserDTO[], readonly totalUsers: number) {}
}
